module.exports = __webpack_public_path__ + "media/application/images/software-advice-frontrunners-badge-1b0c3005a7970974f15c73dd62eb2318.png";